/**
 * @fileoverview Exempt payee code options for W9 tax form
 * @description Provides a frozen array of exempt payee code options (1-13) for use in W9 tax form dropdown selections.
 * Each option contains a label and value pair representing the IRS exempt payee codes.
 */

/**
 * Frozen array of exempt payee code options for W9 tax form
 * @constant {Array<{label: string, value: string}>} ExemptPayeeCodeOptions
 * @description Contains exempt payee codes 1-13 as defined by IRS Form W-9.
 * These codes indicate various types of exemptions from backup withholding.
 */
export const ExemptPayeeCodeOptions = Object.freeze([
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" }
]);